import React from "react";
import LegalLayout from "@/components/legal/LegalLayout";
import { COMPANY } from "@/lib/company";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      lead="Information über die Verarbeitung personenbezogener Daten gemäß Art. 13 DSGVO."
      testId="datenschutz-page"
    >
      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung im Sinne der
        Datenschutz-Grundverordnung (DSGVO) ist:
        <br />
        <br />
        {COMPANY.name}
        <br />
        {COMPANY.street}
        <br />
        {COMPANY.zip} {COMPANY.city}, {COMPANY.country}
        <br />
        Telefon: <a href={`tel:${COMPANY.phoneHref}`}>{COMPANY.phone}</a>
        <br />
        E-Mail: <a href={COMPANY.emailHref}>{COMPANY.email}</a>
      </p>

      <h2>2. Allgemeines zur Datenverarbeitung</h2>
      <p>
        Wir erheben und verwenden personenbezogene Daten unserer Nutzer
        grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen
        Website sowie unserer Inhalte und Leistungen erforderlich ist. Die
        Verarbeitung personenbezogener Daten erfolgt regelmäßig nur nach
        Einwilligung des Nutzers oder auf Grundlage einer gesetzlichen
        Erlaubnis (insbesondere Art. 6 Abs. 1 lit. a, b und f DSGVO).
      </p>

      <h2>3. Bereitstellung der Website &amp; Server-Logfiles</h2>
      <p>
        Bei jedem Aufruf unserer Internetseite erfasst unser System
        automatisiert Daten und Informationen vom Computersystem des aufrufenden
        Rechners (z. B. IP-Adresse, Datum/Uhrzeit, abgerufene Seite, übertragene
        Datenmenge, Browsertyp). Diese Daten werden in den Logfiles des Servers
        gespeichert und nach maximal 14 Tagen automatisiert gelöscht oder
        anonymisiert.
      </p>
      <p>
        Rechtsgrundlage für die vorübergehende Speicherung der Daten ist Art. 6
        Abs. 1 lit. f DSGVO. Das berechtigte Interesse besteht in der
        Sicherstellung eines reibungslosen, sicheren Betriebs der Website.
      </p>

      <h2>4. Kontaktformular</h2>
      <p>
        Auf unserer Website bieten wir ein Kontaktformular an, über das Sie
        Anfragen zu unseren Produkten und Dienstleistungen stellen können. Bei
        der Nutzung des Kontaktformulars werden die von Ihnen angegebenen Daten
        (Name, Firma, E-Mail-Adresse, Telefon, Interessensbereich und Ihre
        Nachricht) zur Bearbeitung Ihrer Anfrage erhoben und gespeichert.
      </p>
      <p>
        Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
        lit. b DSGVO (Vertragsanbahnung) bzw. Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse an der Beantwortung Ihrer Anfrage). Die Daten
        werden ausschließlich für die Bearbeitung der Anfrage verwendet und
        spätestens gelöscht, wenn der Zweck ihrer Erhebung weggefallen ist und
        keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>

      <h2>5. Cookies</h2>
      <p>
        Diese Website verwendet ausschließlich technisch notwendige Cookies, die
        für den Betrieb der Seite erforderlich sind. Eine darüber
        hinausgehende Analyse oder ein Tracking findet nicht statt.
      </p>

      <h2>6. Weitergabe von Daten</h2>
      <p>
        Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den
        im Folgenden aufgeführten Zwecken findet nicht statt. Wir geben Ihre
        persönlichen Daten nur an Dritte weiter, wenn dies gesetzlich zulässig
        ist (z. B. an Auftragsverarbeiter wie Hoster der Website auf Grundlage
        eines Vertrages nach Art. 28 DSGVO).
      </p>

      <h2>7. Rechte der betroffenen Person</h2>
      <p>
        Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung
        (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der
        Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) und
        Widerspruch gegen die Verarbeitung (Art. 21 DSGVO). Soweit die
        Verarbeitung auf einer Einwilligung beruht, können Sie diese jederzeit
        widerrufen (Art. 7 Abs. 3 DSGVO).
      </p>
      <p>
        Bitte richten Sie Ihre Anfragen an die im Impressum genannten
        Kontaktdaten. Darüber hinaus steht Ihnen ein Beschwerderecht bei einer
        Datenschutz-Aufsichtsbehörde zu (Art. 77 DSGVO).
      </p>

      <h2>8. SSL- bzw. TLS-Verschlüsselung</h2>
      <p>
        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
        vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine
        verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des
        Browsers von „http://" auf „https://" wechselt.
      </p>

      <h2>9. Aktualität und Änderung dieser Datenschutzerklärung</h2>
      <p>
        Wir behalten uns vor, die Datenschutzerklärung anzupassen, damit sie
        stets den aktuellen rechtlichen Anforderungen entspricht oder um
        Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch
        gilt dann die jeweils aktuelle Fassung.
      </p>
    </LegalLayout>
  );
}
